import * as pages from 'Pages/index';
import { FC } from 'react';

export interface RouteData {
  permissions: ReadonlyArray<any>;
  page: FC;
}

export const routeMap = new Map<string, RouteData>()
  .set('/', {
    page: pages.OrdersListPage,
    permissions: [],
  })
  .set('/load-page', {
    page: pages.LoadDetailsPage,
    permissions: [],
  })
  .set('/dashboard', {
    page: pages.HomePage,
    permissions: [],
  })

  .set('/capacity', {
    page: pages.Capacity,
    permissions: [],
  })
  .set('/forgot-password', {
    page: pages.ForgotPassword,
    permissions: [],
  })

  .set('/sign-in', {
    page: pages.SignIn,
    permissions: [],
  })

  .set('/sign-up', {
    page: pages.SignUp,
    permissions: [],
  })

  .set('/onboard', {
    page: pages.Onboarding,
    permissions: [],
  })

  .set('/new-password', {
    page: pages.NewPassword,
    permissions: [],
  })

  .set('/loads', {
    page: pages.OrdersListPage,
    permissions: [],
  })
  .set('/load/:id', {
    page: pages.OrderDetailsPage,
    permissions: [],
  })

  .set('/my-bids', {
    page: pages.BidsListPage,
    permissions: [],
  })
  .set('/bid/:id', {
    page: pages.BidDetailsPage,
    permissions: [],
  })

  .set('/my-loads', {
    page: pages.LoadsListPage,
    permissions: [],
  })
  .set('/my-load/:id', {
    page: pages.LoadDetailsPage,
    permissions: [],
  })

  .set('/chat', {
    page: pages.ChatPage,
    permissions: [],
  })

  .set('/notification', {
    page: pages.HomePage,
    permissions: [],
  })

  .set('/dashboard', {
    page: pages.Dashboard,
    permissions: [],
  })
  .set('/addload', {
    page: pages.HomePage,
    permissions: [],
  })
  .set('/units', {
    page: pages.HomePage,
    permissions: [],
  })
  .set('/units/users', {
    page: pages.HomePage,
    permissions: [],
  })
  .set('/accounting', {
    page: pages.HomePage,
    permissions: [],
  })
  .set('/settings', {
    page: pages.Settings,
    permissions: [],
  })
  .set('/home', {
    page: pages.HomePage,
    permissions: [],
  })

  .set('/units/vehicles', {
    page: pages.Vehicles,
    permissions: [],
  })
  .set('/units/drivers', {
    page: pages.Drivers,
    permissions: [],
  })
  .set('/units/partners', {
    page: pages.Partners,
    permissions: [],
  })
  .set('/units/owners', {
    page: pages.Owners,
    permissions: [],
  })
  .set('/health', {
    page: pages.HomePage,
    permissions: [],
  });

export const routeArray = Array.from(routeMap, ([path, r]) => ({ ...r, path }));
